<script setup lang="ts">
import { SolButton } from '@solfacil/girassol'

const props = defineProps<{
  visible: boolean
  selectedCount: number
  inverterBrandLabel: string
  revalidateDisabled?: boolean
}>()

const emit = defineEmits<{
  clearSelection: []
  revalidateSelected: []
}>()

const titleLine = computed(() => {
  const n = props.selectedCount
  if (n === 1)
    return `1 revalidação com inversor ${props.inverterBrandLabel} selecionada.`
  return `${n} revalidações com inversor ${props.inverterBrandLabel} selecionadas.`
})
</script>

<template>
  <Transition name="revalidation-batch-bar">
    <div
      v-if="visible"
      class="revalidation-batch-bar"
      role="region"
      aria-label="Ações em lote para revalidações selecionadas"
    >
      <div class="batch-bar-panel">
        <div class="batch-bar-lead">
          <p class="batch-bar-title">
            {{ titleLine }}
          </p>
          <p class="batch-bar-description">
            Certifique-se de ter preenchido corretamente os dados antes de continuar.
          </p>
        </div>
        <div class="batch-bar-aside">
          <div class="batch-bar-actions">
            <SolButton
              id="revalidation-batch-clear-selection"
              variant="secondary"
              size="large"
              @click="emit('clearSelection')"
            >
              Limpar seleção
            </SolButton>
            <SolButton
              id="revalidation-batch-revalidate-selected"
              variant="primary"
              size="large"
              :disabled="revalidateDisabled"
              @click="emit('revalidateSelected')"
            >
              Revalidar selecionadas ({{ selectedCount }})
            </SolButton>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.revalidation-batch-bar {
  @apply fixed bottom-0 left-0 right-0 z-30;
  @apply flex justify-center pointer-events-none;

  > .batch-bar-panel {
    @apply flex justify-between items-start;
    @apply w-full max-w-7xl pointer-events-auto;
    @apply p-2xs rounded-t-lg;
    @apply bg-neutral-high-light;
    box-shadow:
      0 -4px 12px rgba(0, 0, 0, 0.1),
      0 -2px 6px rgba(0, 0, 0, 0.06),
      8px 0 20px -10px rgba(0, 0, 0, 0.08),
      -8px 0 20px -10px rgba(0, 0, 0, 0.08),
      0 0 4px rgba(0, 0, 0, 0.06);
  }

  > .batch-bar-panel > .batch-bar-lead {
    @apply flex flex-col items-start;
  }

  > .batch-bar-panel > .batch-bar-lead > .batch-bar-title {
    @apply text-neutral-low-dark text-2xs font-bold;
  }

  > .batch-bar-panel > .batch-bar-lead > .batch-bar-description {
    @apply text-feedback-informative-dark text-3xs;
  }

  > .batch-bar-panel > .batch-bar-aside > .batch-bar-actions {
    @apply flex items-center gap-2;
  }
}

.revalidation-batch-bar-enter-active,
.revalidation-batch-bar-leave-active {
  @apply transition-all duration-200 ease-in-out;
}

.revalidation-batch-bar-enter-from,
.revalidation-batch-bar-leave-to {
  @apply opacity-0 translate-y-3;
}
</style>
